import useSWRMutation from "swr/mutation";
import { UserPickerDialog } from "@/components/user-selector";
import type { PickerUser } from "@/components/user-selector";
import { useAppMembers } from "@/hooks/apps";
import { mutateRequest, putFetcher } from "@/lib/swr";

// Manage who can see this app (rows in user_visible_app, app-side view).
// Rendered only for the app's owner or an admin; the server re-checks.
const AppMembersDialog = ({ app }: { app: { id: string; name?: string } }) => {
  const { members, isLoading } = useAppMembers(app.id);
  const { trigger, isMutating } = useSWRMutation(
    `/apps/${app.id}/members`,
    putFetcher,
    {
      onSuccess: () => mutateRequest(`/apps/${app.id}/members`),
    }
  );

  if (isLoading) return null;

  return (
    <UserPickerDialog
      multiple
      selected={members as PickerUser[]}
      onConfirm={(users) =>
        trigger({ userIds: users.map((u) => String(u.id)) })
      }
      title="Manage members"
      description={`Who can see ${app.name ?? "this app"}. The owner always stays a member.`}
      buttonText={isMutating ? "Saving…" : "Edit"}
    />
  );
};

export default AppMembersDialog;
